import { render, staticRenderFns } from "./UploadHipaaModal.vue?vue&type=template&id=3cb1443b&scoped=true"
import script from "./UploadHipaaModal.vue?vue&type=script&lang=js"
export * from "./UploadHipaaModal.vue?vue&type=script&lang=js"
import style0 from "./UploadHipaaModal.vue?vue&type=style&index=0&id=3cb1443b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb1443b",
  null
  
)

export default component.exports